// Точки дистрибуции нативного Android-приложения (TWA). Единый источник
// ссылок на сторы для лендинга, настроек и FAQ — чтобы при смене адреса
// страницы в сторе править одно место.
//
// Pure-модуль без браузерных API (детект платформы — через userAgent.ts).

import { detectPlatform } from './userAgent';

/** Android package id приложения (см. android/, assetlinks.json). */
export const ANDROID_PACKAGE_ID = 'app.favbox';

/** Страница приложения в RuStore (опубликовано июнь 2026). */
export const RUSTORE_APP_URL = `https://www.rustore.ru/catalog/app/${ANDROID_PACKAGE_ID}`;

/**
 * Кому и как предлагать «Скачать из RuStore»:
 * - `'android'` — юзер на телефоне, может установить прямо сейчас (кнопка/бейдж);
 * - `'desktop'` — у юзера может быть Android-телефон рядом (бейдж + QR на
 *   лендинге, мягкая подсказка в настройках);
 * - `null` — не предлагать: iOS (RuStore туда не ставится) или мы уже внутри
 *   установленного приложения (бессмысленно).
 *
 * @param userAgent navigator.userAgent
 * @param installedAppDisplay результат isInstalledAppDisplay() — мы уже внутри
 *   установленного приложения
 */
export type RuStoreOffer = 'android' | 'desktop' | null;

export function ruStoreOffer(
  userAgent: string | null | undefined,
  installedAppDisplay: boolean,
): RuStoreOffer {
  if (installedAppDisplay) return null;
  const platform = detectPlatform(userAgent);
  if (platform === 'ios') return null;
  return platform; // 'android' | 'desktop'
}

/** Shortcut: показывать ли RuStore вообще (в любой форме). */
export function shouldOfferRuStore(
  userAgent: string | null | undefined,
  installedAppDisplay: boolean,
): boolean {
  return ruStoreOffer(userAgent, installedAppDisplay) !== null;
}
